import { httpService } from '@/services/HttpService';
import type { PurchasedGallery } from '../../domain/entities/PurchasedGallery';
import type { PurchasedGalleryRepository } from '../../domain/repositories/PurchasedGalleryRepository';

type PurchasedPhotoApi = {
  id: string;
  filename: string;
  order: number;
  thumbnail_url?: string | null;
  url: string;
  full_url: string | null;
  metadata?: {
    mime_type?: string;
    size?: number;
    width?: number;
    height?: number;
  };
};

type PurchasedGalleryApi = {
  id: string;
  slug: string;
  collaborators: Array<{ id: string; name: string; slug: string | null; avatar: string | null; profile_type: string; role: string }>;
  title: string;
  description: string | null;
  owner: { id: string; name: string };
  category: { id: string; name: string; slug: string } | null;
  photo_count: number;
  allow_download: boolean;
  can_download: boolean;
  purchased_at: string;
  photos: PurchasedPhotoApi[];
};

export class HttpPurchasedGalleryRepository implements PurchasedGalleryRepository {
  async getByAddress(code: string, slug: string): Promise<PurchasedGallery> {
    const response = await httpService.get<{ data: PurchasedGalleryApi }>(
      `/public/content/${code}/${slug}`
    );
    const raw = response.data;

    // Mapear snake_case a camelCase para la UI
    return {
      id: raw.id,
      slug: raw.slug,
      collaborators: raw.collaborators.map((person) => ({
        id: person.id,
        name: person.name,
        slug: person.slug,
        avatar: person.avatar,
        profileType: person.profile_type,
        role: person.role,
      })),
      title: raw.title,
      description: raw.description,
      owner: raw.owner,
      category: raw.category,
      photoCount: raw.photo_count,
      allowDownload: raw.allow_download,
      canDownload: raw.can_download,
      purchasedAt: raw.purchased_at,
      photos: raw.photos.map((photo) => ({
        id: photo.id,
        filename: photo.filename,
        order: photo.order,
        thumbnailUrl: photo.thumbnail_url ?? null,
        url: photo.url,
        fullUrl: photo.full_url,
        metadata: photo.metadata,
      })),
    };
  }
}
